<!--
  Production App Display

 Starts with a Boot Screen

 Then switches to the Paint App

 We may also wire in a DOS App

-->
<template>

  <section id="app">
    <div class="app-content">
      <component :is="state.currentView"></component>
    </div>
  </section>

</template>

<style lang="scss" scoped>


</style>

<script>

  import _ from 'lodash'

  import PaintApp from './components/PaintApp'
  import BootScreen from './components/BootScreen'
  import DosExecutive from './components/DosExecutive'

  import config from './data/config'
  import state from './data/state'


  export default {

    components: {
      PaintApp,
      BootScreen,
      DosExecutive
    },

    data () {
      return {
        state: state
      }
    },

    ready () {
      // listen for command from bootscreen
      this.$on('goNext', this.goNext);
    },

    beforeDestroy() {

    },

    // view instance methods
    methods: {
      goNext() {
        state.currentView = config.devMode ? 'paint-app' : 'dos-executive';
      }

    },

  }
</script>



// WEBPACK FOOTER //
// App.vue?7f72665e